<p class="font-semibold" data-test-id="icd-code-search-title">Search for the applicable ICD-10 codes:</p>

<div class="flex items-start mt-2">
  <div class="inline-flex mr-4">
    <label class="field-required mr-4 pl-2 pt-2" data-test-id="icd-code-label">ICD-10 Code:</label>

    <form [formGroup]="form">
      <input
        pInputText
        type="text"
        class="icd-code-search"
        formControlName="searchControl"
        data-test-id="icd-code-search-input"
      />
      <errors-messages [control]="form?.get('searchControl')"></errors-messages>
    </form>
  </div>

  <button
    pButton
    label="Search"
    icon="pi pi-search"
    iconPos="left"
    [disabled]="form.invalid || form.get('searchControl')?.disabled"
    (click)="searchICD()"
    data-test-id="icd-search-button"
  ></button>
</div>
